const toPercent = (num: number, fractionDigits: number | undefined = 2) => {
  return num.toLocaleString("en-US", {
    style: "percent",
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
};

export default toPercent;
